import Icon from "@material-ui/icons/School";
//import Edit from "./CertificationEdit";
//import Show from "./CertificationShow";
//import Create from "./CertificationCreate";
import List from "./CertificationList";

export default {
 // edit: Edit,
 // create: Create,
  icon: Icon,
  list: List,
 // show: Show,
};
